import { API } from "../APIs/index";
import { Pagination, Tokens } from "../Interfaces/Interfaces";
import { TokenValidator } from "./TokenValidator";

export default class POSService {
  tokens: any | Tokens;
  get = API.pos + "get/";
  post = API.pos + "post/";
  put = API.pos + "put/";
  getAggregator = API.aggregator + "get/";
  constructor() {
    this.tokens = TokenValidator();
  }

  async getDashboard(id: string) {
    try {
      let response = await fetch(
        this.get + `PosTerminal/GetAggregatorPosTerminalDashboard/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getTerminalDetails(id: string) {
    try {
      let response = await fetch(this.get + `PosTerminal/getDetails/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAggregatorTerminals(data: Pagination) {
    try {
      let response = await fetch(
        this.get +
          `PosTerminal/getAggregatorTerminals/${data.id}/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getSuperAggregatorTerminals(data: Pagination) {
    try {
      let response = await fetch(
        this.get + `PosTerminal/GetAggregatorAssignedTerminals`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAggregatorAssignedTerminals(data: Pagination) {
    try {
      let response = await fetch(
        this.get +
          `PosTerminal/GetAgentAssignedTerminals/${data.id}/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getPosAggregatorTransactions(data: Pagination) {
    try {
      let response = await fetch(
        this.get +
          `PosTransactionLog/getaggregatortransactions/${data.id}/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAgentAssignedTerminals(data: any) {
    try {
      let response = await fetch(
        this.get +
          `PosTerminal/GetAgentAssignedTerminals?agentId=${data}
          `,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getUnAssignedTerminals(data: any) {
    try {
      let response = await fetch(
        this.get +
          `PosTerminal/GetUnAssignedAgentTerminalsForAggregator?aggregatorId=${data}
          `,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getUnAssigneTerminalsForSuperAggregator() {
    try {
      let response = await fetch(
        this.get +
          `PosTerminal/GetUnAssignedTerminalsForSuperAggregator
          `,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async getCoordinatorTerminals(data: Pagination) {
    try {
      let response = await fetch(
        this.get +
          `PosTerminal/getCoordinatorTerminals/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAgentTerminals(data: Pagination) {
    try {
      let response = await fetch(
        this.get +
          `PosTerminal/getAgentTerminals/${data.id}/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAggregatorAssignedRequests(data: Pagination) {
    try {
      let response = await fetch(
        this.get +
          `PosTerminalAction/getAggregatorAssignedRequests/${data.id}/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getTerminalTransactions(data: Pagination) {
    try {
      let response = await fetch(
        this.get +
          `PosTerminal/getTerminalTransactions/${data.id}/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getTerminalDashboard(id: string) {
    try {
      let response = await fetch(
        this.get + `PosTerminal/GetTerminalDashboard/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async agentTerminalRequest(data: Pagination) {
    try {
      let response = await fetch(
        this.get +
          `agentTerminalRequest/getAggregatorRequests/${data.id}/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async recommendRequestByAggregator(data: any) {
    try {
      let response = await fetch(
        this.post + `agentTerminalRequest/RecommendRequestByAggregator`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async retrieveMultipleTerminalsFromAgent(data: any) {
    try {
      let response = await fetch(
        this.put + `PosTerminal/RetrieveMultipleTerminalsFromAgent`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async retrieveMultipleTerminalsFromAggregator(data: any) {
    try {
      let response = await fetch(
        this.put + `PosTerminal/RetrieveMultipleTerminalsFromAggregator`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async addPNDToMultipleTerminalsServices(data: any) {
    try {
      let response = await fetch(
        this.post + `PosTerminal/ApplyPndToMultipleTerminals`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async placeTerminalOnPnd(data: any) {
    try {
      let response = await fetch(this.post + `PosTerminal/ApplyPnd`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  //placeTerminalOnPnd

  async startMultipleTerminalsFromAgent(data: any) {
    try {
      let response = await fetch(
        this.post + `PosTerminal/StartMultipleTerminals`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async assignMultipleTerminalsToAgent(data: any) {
    try {
      let response = await fetch(
        this.post + `PosTerminal/AssignMultipleTerminalsToAgent`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async assignMultipleTerminalsToAggregator(data: any) {
    try {
      let response = await fetch(
        this.post + `PosTerminal/AssignMultipleTerminalsToAggregator`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async stopMultipleTerminalsToAgent(data: any) {
    try {
      let response = await fetch(
        this.post + `PosTerminal/StopMultipleTerminals`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async toggleTerminalState(id: any) {
    try {
      let response = await fetch(this.put + `posTerminal/ToggleState/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify({}),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async retrieveTerminal(data: any) {
    try {
      let response = await fetch(
        this.put + `posTerminal/RetrieveTerminalFromAgentByAggregator`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async retrieveTerminalAggregator(data: any) {
    try {
      let response = await fetch(this.put + `posTerminal/RetrieveTerminal`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async assignTerminal(data: any) {
    try {
      let response = await fetch(
        this.post + `posTerminal/AssignTerminalToAgent`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async assignMultipleTerminal(data: any) {
    try {
      let response = await fetch(
        this.post + `PosTerminal/AssignMultipleTerminalsToAgent`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async assignMultipleTerminalToAggregatorServices(data: any) {
    try {
      let response = await fetch(
        this.post + `PosTerminal/AssignMultipleTerminalsToAggregator`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async declineRequestByAggregator(data: any) {
    try {
      let response = await fetch(
        this.post + `agentTerminalRequest/declineRequestByAggregator`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getPOSDashboard(id: any) {
    try {
      let response = await fetch(
        this.get + `PosTerminal/GetTerminalDashboard/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getPOSTransactions(data: Pagination) {
    try {
      let response = await fetch(
        this.get +
          `PosTransactionLog/getTerminalTransactions/${data.id}/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getPOSTransactionDetails(id: string) {
    try {
      let response = await fetch(
        this.get + `PosTransactionLog/getDetails/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAggregatorPOSTransactions(data: Pagination) {
    try {
      let response = await fetch(
        this.get +
          `PosTransactionLog/getAggregatorTransactions/${data.id}/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAggregatorAgents(id: number) {
    try {
      let response = await fetch(
        this.get + `PosTerminal/getAggregatorAgents/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getSuperAggregatorAggregator() {
    try {
      let response = await fetch(
        this.getAggregator + `aggregator/nameandvalues`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getCordinatorDashboard() {
    try {
      let response = await fetch(
        this.get + `PosTerminal/getCoordinatorDashboard`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getStartedAndStoppedTerminals(agentId: number) {
    try {
      let response = await fetch(
        this.get + `PosTerminal/getAgentStartedAndStoppedTerminals/${agentId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async sendOtp(data: any) {
    try {
      let response = await fetch(
        this.post + `Merchants/send-transfer-otp`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async verifyOtp(data: any) {
    try {
      let response = await fetch(
        this.post + `Merchants/verify-otp`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  //getStartedAndStoppedTerminalsReducer
}
